import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-division-diaglog-box',
  templateUrl: './division-diaglog-box.component.html',
  styleUrls: ['./division-diaglog-box.component.scss']
})
export class DivisionDiaglogBoxComponent implements OnInit {
  displayColumns = [ 'DivisionCode', 'DivisionName'];
  DivisionForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  divisionList: any;
  isreadonlydel = false;
  division: string;
  list;
  divisionform: any;
  DivisionSearchForm;
  APIService: any;
  deleteButton: boolean;
  DivisionCodefordelete;
  isreadonly = false;
  dialogRef: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  StateCodeList: any;
  filteredListStateCode: any;
   userPermission:any;
  utp: any;
  DivCreate = true;
DivUpdate = true;
DivDelete = true;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<DivisionDiaglogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
              private fb: FormBuilder,   public router: Router, private httpClient: HttpClient,
              private route: ActivatedRoute, private spinner:NgxSpinnerService, ) {this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
  this.utp = sessionStorage.getItem('usertypeee');
  if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
    // this.isSuperAdmin= false;
    this.userPermission.forEach(element => {
    if(element.PageName == 'Division' && element.PCreate == false)
    {
        this.DivCreate = false;  
    }
    if(element.PageName == 'Division' && element.PUpdate == false)
    {
        this.DivUpdate = false;  
    }   
    if(element.PageName == 'Division' && element.PDelete == false)
    {
        this.DivDelete = false;  
    } 
  });
}
    window.scroll(0, 0);
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.getDivisionData();
    this.fetchCountryCode();
    // this.fetchStateCode(id);
    this.list = true;
    this.DivisionForm = this.fb.group({
      DivisionCode: new FormControl('',  [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      DivisionName: new FormControl('', [Validators.required]),
      CountryCode: new FormControl('', [Validators.required]),
      StateCode: new FormControl('', [Validators.required]),

    });
    this.DivisionSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
    if (this.data.key == "Edit") { 
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.deletee(this.data.selected);
    } else {
      // alert(this.data.key)
    }
  }

  getDivisionData() {
      this.spinner.show();
        const payload = {};
        this.umsService.getDivision(payload).subscribe(res => {
      this.divisionList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.divisionList = [];
      let  data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   });
  }

  prepopulation(id) {
    this.spinner.show();
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    payload['DivisionCode'] = id;
    // tslint:disable-next-line:no-string-literal
    
    this.umsService.getDivision(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
    this.fetchStateCode2(data.CountryCode);
      if (res.status) {
        this.editButton = true;
        this.isreadonly = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.DivisionForm = this.fb.group({
          DivisionCode: new FormControl(data.DivisionCode, [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
          DivisionName: new FormControl(data.DivisionName, [Validators.required]),
          CountryCode: new FormControl(data.CountryCode, [Validators.required]),
          StateCode: new FormControl(data.StateCode, [Validators.required]),
        });
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  deletedata(id){
    const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),  body: {
      DivisionName: id.DivisionName,
      DivisionCode: id.DivisionCode,
      CountryCode: id.CountryCode,
      StateCode: id.StateCode

    },
  };
    this.httpClient.delete(this.APIService + '/masters/division', options)
    .subscribe((s) => {
      // this.spinner.hide();
      let cc = [];
      cc.push(s);
      let  data = {}
      data['message'] = cc[0].message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();
      });
    },(ERROR: HttpErrorResponse) => {

      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

   });

   }


   deletee(k){
    // if (e === 'true'){
      this.list = false;
      this.getDivisionData();
      const payload = {};
      // tslint:disable-next-line:no-string-literal
      payload['DivisionCode'] = k;
      // tslint:disable-next-line:no-string-literal
      this.umsService.getDivision(payload).subscribe((res) => {
        const data = res.data[0];
        if (res.status) {
          this.editButton = false;
          this.submitButton = false;
          this.isreadonlydel = true;
          this.deleteButton = true;
          this.DivisionForm = this.fb.group({
            DivisionCode: new FormControl(data.DivisionCode, [Validators.required,Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
            DivisionName: new FormControl(data.DivisionName, [Validators.required]),
            CountryCode: new FormControl(data.CountryCode, [Validators.required]),
            StateCode: new FormControl(data.StateCode, [Validators.required]),
          });
          this.DivisionCodefordelete =  this.DivisionForm.value;
        } else {
          let  data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-box-open'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      });
    // } else {
    //   this.list = true;
    // }
  }
  openConformationModalBox(){
    let  data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if(result == 'yes'){
        this.deletedata(this.DivisionForm.value);
        this.dialogRef2.close();
      }else{
        // this.ngOnInit();
        this.dialogRef2.close();
      } 
    });
   }

  keypress(){
    this.umsService.searchDivision(this.DivisionSearchForm.value).subscribe(res => {
      this.divisionList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.divisionList = [];
      });
  }

  submit() {
    if (this.DivisionForm.invalid) {
      this.DivisionForm.get('DivisionCode').markAsTouched();
      this.DivisionForm.get('DivisionName').markAsTouched();
      this.DivisionForm.get('CountryCode').markAsTouched();
      this.DivisionForm.get('StateCode').markAsTouched();
      return;
    } else {
      this.createDivision();
    }
  }

  

  createDivision() {
    this.spinner.show();
    this.submitpayload = this.DivisionForm.value;
    this.umsService.addDivision(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result)=> {
          // this.dialogRef2.close();
        });
        
        
      } else {
        let  data = {}
        this.spinner.hide();
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        
      }
    },(ERROR: HttpErrorResponse) => {
      this.divisionList = [];
      this.spinner.hide();
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   });
  }

  update() {
    if (this.DivisionForm.invalid) {
      this.DivisionForm.get('DivisionCode').markAsTouched();
      this.DivisionForm.get('DivisionName').markAsTouched();
      this.DivisionForm.get('CountryCode').markAsTouched();
      this.DivisionForm.get('StateCode').markAsTouched();
      return;
    } else {
      this.updateDivision();
    }
  }

  updateDivision() {
    this.spinner.show();
    this.submitpayload = this.DivisionForm.value;
    this.umsService.updateDivision(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status){
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        let  data = {}
        this.spinner.hide();
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
         // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    },(ERROR: HttpErrorResponse) => {
      let  data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.spinner.hide();
   });
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      this.isreadonly = false;
      this.getDivisionData();
      // this.DivisionForm = k;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
   }

   fetchCountryCode() {
    this.spinner.show();
    const payload = {};
    // payload['CountryCode'] = id;
    // payload['CountryName'] = id;
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {    
        this.CountryCodeList = res.data;
        this.filteredListCountryCode= this.CountryCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
  } 

  fetchStateCode(CountryCode) {
    this.spinner.show();
    this.StateCodeList = [];
    const payload = {};
    payload['CountryCode'] = CountryCode;
    // payload['StateName'] = id;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {    
        this.StateCodeList = res.data;
        this.filteredListStateCode= this.StateCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  } 

  fetchStateCode2(CountryCode) {
    this.spinner.show();
    this.StateCodeList = [];
    const payload = {};
    payload['CountryCode'] = CountryCode;
    // payload['StateName'] = id;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {    
        this.StateCodeList = res.data;
        this.filteredListStateCode= this.StateCodeList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
        this.spinner.hide();
      }
    })
  } 


}


 